// Where the run log lives: its own page, or a side panel over the agent tab (`runLog=<roleKey>`).
// `run=<id>` opens that run in either.

export const RUN_LOG_PARAM = 'runLog';
export const RUN_PARAM = 'run';
/** The client facts side panel over the agent tab (`facts=<roleKey>`). */
export const FACTS_PARAM = 'facts';
/** The observations side panel over the agent tab (`observations=<roleKey>`). */
export const OBSERVATIONS_PARAM = 'observations';

/** The run log's own page. */
export function runLogPagePath(
  practiceId: string,
  locationId: string,
  roleKey: string,
  runId?: string,
): string {
  const base = `/agency/practices/${practiceId}/locations/${locationId}/agents/${roleKey}/runs`;
  return runId ? `${base}?${RUN_PARAM}=${encodeURIComponent(runId)}` : base;
}

/** The agent tab, with the run log open in its side panel when `panel` is set. */
export function agentTabPath(
  practiceId: string,
  locationId: string,
  panel?: { roleKey: string; runId?: string },
): string {
  const params = new URLSearchParams({ tab: 'agents', location: locationId });
  if (panel) {
    params.set(RUN_LOG_PARAM, panel.roleKey);
    if (panel.runId) params.set(RUN_PARAM, panel.runId);
  }
  return `/agency/practices/${practiceId}?${params.toString()}`;
}
